import { Component } from "react";
import withAuth from "../withAuth";
import Checkbox from "@mui/material/Checkbox";
import "./SmallLabelAndCheckBox.css";

class SmallLabelAndCheckBox extends Component {
    render() {
        return (
            <>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding">
                    <span className="label-small-label-check-box">{this.props.label}</span>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding">
                    <Checkbox checked={this.props.checked} className="small-checkbox" onChange={this.props.onChange} />
                </div>
            </>
        );
    }
}

export default withAuth(SmallLabelAndCheckBox);
